require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-ربح-الأموال.json") })
        }
      }, "path---tags-ربح-الأموال");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-ربح-الأموال!./.cache/json/tags-ربح-الأموال.json
// module id = 609
// module chunks = 231608221292675